"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _events = require("../../utilities/events");
var _Radio = require("./Radio.styles");
var _jsxRuntime = require("react/jsx-runtime");
var Radio = function Radio(props) {
  var id = props.id,
    isChecked = props.isChecked,
    isDisabled = props.isDisabled,
    label = props.label,
    onClick = props.onClick;
  var styles = (0, _Radio.useStyles)(props);
  var handleClick = function handleClick() {
    if (!isDisabled && onClick) {
      onClick(id);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    (0, _events.handleSpaceOrEnterDown)(event, handleClick);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Radio'],
    tabIndex: isDisabled ? -1 : 0,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: styles['cc-Radio__btn'],
      role: "radio",
      "aria-checked": isChecked,
      "aria-disabled": isDisabled,
      "aria-label": id
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Radio__label'],
      children: label
    })]
  }, "cc-Radio--".concat(id));
};
exports.Radio = Radio;